import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import * as pt from 'prop-types';

class ModalHeader extends Component {
    constructor (props) {
        super(props);
    }

    render () {
        let {
            children, cancelModal
        } = this.props;

        return (<div className="invintus-modal-title">
            <h2>{children}</h2>
            {
                (!!cancelModal) ?
                    <span className="close-modal" onClick={cancelModal}>
                        <i className="fa fa-times"/>
                    </span> :
                    null
            }
        </div>);
    }
}

export default ModalHeader;
